import pushGTMEvent from '../../util/helper/pushGTMEvent';
import { isEmpty } from '../../util/util';

const configContents = ({
  state: {
    langStrings,
    user,
    hulaResponse,
    currentHULADetails,
  },
}) => {
  const { productKey, productVersionKeys, selectedProduct} = currentHULADetails;
  const { requestedVersion, numberOfSeats } = hulaResponse.data;
  const expirationDate =  `${productVersionKeys.hasContractEndDate}`
  let successMessage = '';
  
  if(!isEmpty(selectedProduct) && isEmpty(expirationDate)) {
    // Default...
    successMessage = `${selectedProduct} ${requestedVersion} (for ${numberOfSeats} seats) <br/>
    Serial number: ${hulaResponse.data.serialNumber}<br/>
    Product key: ${productKey}<br/>`
  }
  if(!isEmpty(selectedProduct) && !isEmpty(expirationDate)) {
    successMessage = `${selectedProduct} ${requestedVersion} (for ${numberOfSeats} seats) <br/>
    Serial number: ${hulaResponse.data.serialNumber}<br/>
    Product key: ${productKey}<br/>
    Expiration Date: ${expirationDate}`
  }
  console.log('Success page : ', successMessage)
  return [
    {
      isTitle: true,
      hasSuccessMark: true,
      description: langStrings
        ? langStrings.successScreen.pageTitle
        : 'Success',
      id: 'adsk-page-title',
    },
    {
      description: langStrings
        ? langStrings.successScreen.responseText1
        : "Your home use license request was approved.",
      paragraphStyle: { marginBottom: '20px' },
      style: {
        color: '#333',
        fontWeight: 300,
        marginbottom: '20px',
      },
    },
    {
      description: langStrings
        ? langStrings.successScreen.responseText2
        : "Install and activate your software using the following information. Select “stand-alone” during installation.",
      paragraphStyle: { marginBottom: '30px' },
      style: {
        color: '#333',
        fontWeight: 300,
        fontSize: '13px',
      },
    },
    {
      BGColor: '#f7fcfe',
      BGPadding: '8px 20px 20px',
      description: successMessage,
      style: {
        color: '#333',
        fontWeight: 700,
      },
      paragraphStyle: { marginBottom: '10px' },
    },
    {
      description: langStrings
        ? langStrings.successScreen.infoWillBeEmailed
            .replace('<email>', user.email)
        : "This information will also be emailed to you at: <email>".replace('<email>', user.email),
      paragraphStyle: { margin: '20px 0 20px' },
      style: {
        color: '#333',
        fontWeight: 400,
        fontSize: '13px',
      },
    },
  ];
}

const configFooter = ({
  state: {
    langStrings,
    hasExtension,
  },
  dispatch,
}) => ({
  hasQuestion: true,
  hasExtension,
  hideBackButton: true,
  nextButtonContent: langStrings ? langStrings.buttons.restartButton : 'RESTART',
  handleNext: () => {
    dispatch({ type: 'RESTART_WIDGET' })
    window.location.reload(true);
  },
  handleExtension: () => dispatch({ type: 'TOGGLE_QUESTION_EXTENSION' }),
  handleAgentLoad: () => dispatch({ type: 'AGENT_LOADED' }),
  handleAgentAvailable: (flag) => dispatch({ type: 'AGENT_AVALIABLE', payload: { isAgentAvailable: flag } }),
  handleAgentAnalytics: () => pushGTMEvent('ChatWithAgent'),
  handleCaseAnalytics: () => pushGTMEvent('CreateCase'),
  handleNextButtonId: 'adsktm-cm-next-button',
  handleAgentButtonId: 'adsktm-agent-button',
  handleCaseButtonId: 'adsktm-case-button',
  handleQuestionButtonId: 'adsktm-have-question-button',
  handleSupportAnalytics: () => pushGTMEvent('ContactSupport'),
});

export default {
  configContents,
  configFooter,
};
